// src/ui/tokens.js
export const ui = {
  colorPrimary: "#134B70",
  colorPrimaryHover: "#0F3B57",
    icon: {
    edit:  { base: "#264bceff", hover: "#264bceff" },
    del:   { base: "#ab2e2eff", hover: "#ab2e2eff" },
  },
  card: {
    p: 3,
    maxWidth: "50%",
    mx: "auto",
    mt: 6, // empuja hacia abajo
    borderRadius: 3,
    boxShadow: "0 16px 40px rgba(0,0,0,.08)",
    background: "#fff",
  },
  btnPrimary: {
    bgcolor: "#134B70",
    color: "#fff",
    fontWeight: 700,
    textTransform: "none",
    borderRadius: 2,
    px: 2.5,
    "&:hover": { bgcolor: "#0F3B57" },
  },
  btnOutline: {
    borderColor: "#134B70",
    color: "#134B70",
    textTransform: "none",
    borderRadius: 2,
    px: 2.5,
    "&:hover": { borderColor: "#0F3B57", bgcolor: "rgba(19,75,112,.06)" },
  },
  label: { color: "text.primary", fontWeight: 600 },
};